import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Row,
  Col,
  Collapse,
  Spinner,
} from "reactstrap";
// componentes
import SectionComponent from "../../Apps/Personalization/SectionComponent";
// utils
import { loadEventForms } from "./createXlsxDynamic";

export default function ModalExportParticipants(props) {
  const { isOpen, toggle, eventId, onExportSimple, onExportDynamic } = props;

  // sessoes
  const [sectionSimple, setSectionSimple] = useState(false);
  const [sectionDynamic, setSectionDynamic] = useState(false);
  // formularios do evento
  const [loadingForms, setLoadingForms] = useState(false);
  const [forms, setForms] = useState([]);
  const [formsLoaded, setFormsLoaded] = useState(false);
  const [selectedForms, setSelectedForms] = useState([]);
  // erros
  const [formsError, setFormsError] = useState("");
  const [requestError, setRequestError] = useState("");

  // abre/fecha a sessão do relatório simples
  function verifySimple() {
    setSectionSimple(!sectionSimple);
    setSectionDynamic(false);
  }

  // abre/fecha a sessão do relatório dinâmico e busca os formulários na
  // primeira abertura
  async function verifyDynamic() {
    const willOpen = !sectionDynamic;
    setSectionDynamic(willOpen);
    setSectionSimple(false);

    if (!willOpen || formsLoaded) return;

    setLoadingForms(true);
    setRequestError("");
    try {
      const eventForms = await loadEventForms({ eventId });
      setForms(eventForms);
      setFormsLoaded(true);
    } catch (error) {
      setRequestError(
        "Não foi possível carregar os formulários do evento. Tente novamente.",
      );
    }
    setLoadingForms(false);
  }

  // marca/desmarca um formulário
  function toggleForm(formId) {
    setFormsError("");
    setSelectedForms((prev) =>
      prev.includes(formId)
        ? prev.filter((e) => e !== formId)
        : [...prev, formId],
    );
  }

  // marca/desmarca todos os formulários
  function toggleAllForms() {
    setFormsError("");
    setSelectedForms((prev) =>
      prev.length === forms.length ? [] : forms.map((e) => e.id),
    );
  }

  // dispara o relatório simples (mesmo comportamento do botão exportar atual)
  function exportSimple() {
    onExportSimple();
    toggle();
  }

  // dispara o relatório dinâmico com os formulários selecionados. A ordem
  // segue a da lista de formulários e, dentro de cada um, a ordem dos campos.
  function exportDynamic() {
    if (selectedForms.length === 0) {
      setFormsError("Selecione ao menos um formulário");
      return;
    }

    onExportDynamic({
      selectedForms: forms.filter((form) => selectedForms.includes(form.id)),
    });
    toggle();
  }

  return (
    <Modal isOpen={isOpen} autoFocus centered>
      <ModalHeader toggle={toggle}>Exportar participantes</ModalHeader>
      <ModalBody>
        <Row>
          <SectionComponent
            sectionName="Relatório Simples"
            setIsOpen={verifySimple}
            isOpen={sectionSimple}
          />
        </Row>

        <Collapse isOpen={sectionSimple}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}
          >
            <Button
              color="success"
              className="btn btn-success waves-effect waves-light"
              style={{ width: "300px" }}
              onClick={exportSimple}
            >
              Gerar relatório simples
            </Button>
          </div>
        </Collapse>

        <Row style={{ marginTop: 10 }}>
          <SectionComponent
            sectionName="Relatório com Atributos Dinâmicos"
            setIsOpen={verifyDynamic}
            isOpen={sectionDynamic}
          />
        </Row>

        <Collapse isOpen={sectionDynamic}>
          {loadingForms && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              <Spinner color="success" />
            </div>
          )}

          {!loadingForms && requestError && (
            <span style={{ color: "red" }}>{requestError}</span>
          )}

          {!loadingForms &&
            !requestError &&
            formsLoaded &&
            forms.length === 0 && (
              <span style={{ display: "block", marginTop: 10 }}>
                Nenhum formulário encontrado para este evento.
              </span>
            )}

          {!loadingForms && forms.length > 0 && (
            <>
              <p style={{ marginTop: 10, marginBottom: 5 }}>
                Selecione o(s) formulário(s) que deseja extrair os dados.
              </p>

              <Row>
                <div>
                  <label
                    className="switch"
                    style={{ display: "flex", marginTop: 10 }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedForms.length === forms.length}
                      onChange={toggleAllForms}
                    />
                    <span className="slider round" style={{ marginLeft: 10 }}>
                      Selecionar todos
                    </span>
                  </label>
                </div>

                {forms.map((form) => (
                  <div key={form.id}>
                    <label className="switch" style={{ display: "flex" }}>
                      <input
                        type="checkbox"
                        checked={selectedForms.includes(form.id)}
                        onChange={() => toggleForm(form.id)}
                      />
                      <span className="slider round" style={{ marginLeft: 10 }}>
                        {form.description}
                      </span>
                    </label>
                  </div>
                ))}
              </Row>

              {formsError && <span style={{ color: "red" }}>{formsError}</span>}

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <Row>
                  <Col md={12}>
                    <Button
                      color="success"
                      className="btn btn-success waves-effect waves-light"
                      style={{ width: "300px" }}
                      onClick={exportDynamic}
                    >
                      Gerar relatório dinâmico
                    </Button>
                  </Col>
                </Row>
              </div>
            </>
          )}
        </Collapse>
      </ModalBody>
    </Modal>
  );
}
